
import { Vue, Component, Prop } from "vue-property-decorator";
import { IMessage } from "@/schemas/IMessage";
import { mapState } from "vuex";
import { assetsUrl } from "@/env";
import { IResult } from "@/schemas/IResult";
import { randomColor } from "@/utils";
import { IUser } from "@/schemas/IUser";

@Component({
  name: "ChatBubble",
  computed: {
    ...mapState("user", { currentUserId: "userId" }),
    ...mapState("user", ["userId"]),
    ...mapState("session", ["session", "users"]),
  },
})
export default class dockChatBubble extends Vue {
  @Prop({ required: true })
  message!: IMessage;
  readonly sessionId!: string;

  // @Prop({ type: String, required: true })
  // currentUserId!: string;

  @Prop({ type: String, required: true })
  username!: string;

  @Prop({ type: String, required: true })
  color!: string;
  //
  // const emoji_ico_prefixe =
  //   '<img class="emoji_room_img" src="/assets/chat_emojis/';
  // const emoji_ico_suffixe = '">';

  data(): any {
    return {
      showArrow: false,
      userColor: "red",
      results: "",
    };
  }

  created(): void {
    // We need the results to know the user colors
    this.$store.dispatch("session/getSessionResults", {
      sessionId: this.message.session_id,
      next: (results: IResult[]) => {
        this.results = results;
      },
    });
  }

  getAnswerColor(userId: string): string {
    let color = this.getUserColor(userId);
    switch (color) {
      case "lime":
        color = "#cddc39";
        break;
      case "pink":
        color = "#e91e63";
        break;
      case "green":
        color = "#4CAF50";
        break;
      case "amber":
        color = "#ffc107";
        break;
      case "indigo":
        color = "#3f51b5";
        break;
      case "blue":
        color = "#2196F3";
        break;
    }

    return color;
  }

  getUserColor(userId: string): string {
    if (this.results) {
      let userResult = this.results.find(
        (res: IResult) => res.user_id == userId
      );
      return (
        userResult?.color ||
        randomColor(
          this.users.findIndex((user: IUser) => user.id === userId)
        ) ||
        ""
      );
    }
    return (
      randomColor(this.users.findIndex((user: IUser) => user.id === userId)) ||
      ""
    );
  }

  getImageSrc(slug: string): string {
    return `${assetsUrl}/${slug}`;
  }

  toggleArrow() {
    // mobile tap
    this.showArrow = !this.showArrow;
  }
  replyToMessage(message) {
    this.$emit("answerTo", message);
  }

  getMessageContent(message) {
    const substring =
      '<img class="emoji_room_img" src="/assets/chat_emojis/emoji_';
    if (message.answerTo_Content.includes(substring)) {
      const imgRegex = /<img class="emoji_room_img"[^>]*>/g;
      const images = message.answerTo_Content.match(imgRegex) || [];
      const imageCount = images.length;
      const maxTextLen = Math.max(0, 30 - imageCount);

      let charCount = 0;
      let result = "";
      let inTag = false;
      let htmlContent = message.answerTo_Content;
      let i = 0;

      while (i < htmlContent.length && charCount < maxTextLen) {
        if (htmlContent[i] === "<") {
          inTag = true;
          result += htmlContent[i];
        } else if (htmlContent[i] === ">") {
          inTag = false;
          result += htmlContent[i];
        } else if (!inTag) {
          result += htmlContent[i];
          charCount++;
        } else {
          result += htmlContent[i];
        }
        i++;
      }

      const hasMoreContent = i < htmlContent.length;
      return hasMoreContent ? result + "..." : result;
    }

    message.contentTrimmed = message.answerTo_Content;
    if (message.contentTrimmed.length > 30) {
      return message.contentTrimmed.slice(0, 30) + "...";
    } else {
      return message.contentTrimmed;
    }
  }

  getMessageContentFull(message) {
    return message.answerTo_Content;
  }
}
